import React from 'react';
import { Hint } from '@/components/ui';
import { CsvFileHoverCard } from '@/components/data-import/CsvFileHoverCard';
import { formatFileSize } from '@/utils/fileUtils';
import type { SelectedFile } from '../types';
import { IconInfoCircle } from '@tabler/icons-react';

interface FileInfoHintProps {
  file: SelectedFile;
}

export const FileInfoHint: React.FC<FileInfoHintProps> = ({ file }) => {
  const hintText = `${formatFileSize(file.metadata.size)} • ${file.metadata.columnCount} columns • ${file.metadata.rowCount.toLocaleString()} rows`;

  // Only show HoverCard if we have csvFile (for uploaded files, we don't have full CsvFile data)
  if (file.csvFile) {
    return (
      <CsvFileHoverCard
        file={file.csvFile}
        columns={file.metadata.columnCount}
        rows={file.metadata.rowCount}
      >
        <Hint style={{ cursor: 'pointer' }} icon={<IconInfoCircle />}>
          {hintText}
        </Hint>
      </CsvFileHoverCard>
    );
  }

  // For uploaded files, just show hint without hover card
  return <Hint>{hintText}</Hint>;
};
